export default class ExtensionLoader {


	/**  @type {Map}  */
	extensions = null;
	/**  @type {Object}  */
	global = null;

	constructor(naja, extensions, global) {
		this.naja = naja;
		this.extensions = extensions;
		this.global = global;
		this.naja.addEventListener('load', this.validate.bind(this));
	}

	validate() {
		this.extensions.forEach((value, key) => {
			if (document.querySelector(key)) {
				this.extensions.delete(key);
				value().then(this.load.bind(this));
			}
		});
	}

	load({default: Extension}) {
		this.naja.registerExtension(Extension, new Extension(this.naja, this.global));
	}
}
